export default {
  title: 'Filtereinstellungen',
  timeInterval: 'Zeitintervall',
  additionalFilters: 'Zusätzliche Filter',
  noWeekdaysNotification: 'Mindestens ein Wochentag sollte ausgewählt werden',
  lagging: {
    lagging: 'Verzögerung',
    isLagging: {
      true: 'Nur bei Beginn',
      false: 'Nur bei Ende',
    },
    all: 'Bei Beginn und Ende',
  },
  newState: 'Neuer Status',
  assignee: 'Zugewiesen an',
  created: 'Erstellt von',
};
